<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17wbSR4/tc-custom/9781429944434.jpg?1737767945732" alt="This image is the cover for the book Four and Twenty Blackbirds, Eden Moore"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Four and Twenty Blackbirds, Eden Moore
      </h1>
      <p class="bookDescription body article font2">
        <b>Ghosts and assassins spur an young orphaned Tennessee woman to investigate her family’s mysterious past in this edgy Southern gothic fantasy.</b><br/><br/><b>“Cherie Priest kicks ass! <i>Four and Twenty Blackbirds</i> is lush, rich, intense, and as dark and dangerous as a gator-ridden swamp.” —Maggie Shayne, <i>New York Times</i>–bestselling author of <i>Blue Twilight</i></b><br/><br/>Although she was orphaned at birth, Eden Moore is never alone. Three dead women watch from the shadows, bound to protect her from harm. But outside her aunt’s house a gunman waits, convinced that Eden is destined to follow her wicked great-grandfather, an African magician with the power to curse the living and raise the dead.<br/><br/>Now Eden must decipher the ghostly trio’s secret before a new enemy more dangerous than the fanatical assassin destroys what is left of her family. She will sift through lies in a Georgian ante-bellum mansion and climb through the haunted ruins of an abandoned hospital, desperately seeking the truth that will save her beloved aunt from the curse that threatens her life . . . <br/><br/><b>“Spooky and engrossing, this revenge play is as sticky as a salmagundi made from blood and swamp dirt. Priest can write scenes that are jump-out-of-your-skin scary. This is the first installment in what I can only hope will be a long and terrifying friendship.” —Cory Doctorow</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cherie Priest
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?60cc5767